import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { notify } from "reapop";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Grid, Button, CircularProgress, Typography } from "@material-ui/core";
import { MyForm, MyInput } from "../../components";
import { Link } from "react-router-dom";
import { useDocTitle } from "../../hooks/useDocTitle";
import useAuth from "../../hooks/useAuth";
import clsx from "clsx";
import * as Yup from "yup";

const useStyles = makeStyles((theme) => ({
  header: {
    fontWeight: "900",
    paddingTop: theme.spacing(1),
    textAlign: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    color: "#1976d2",
    textDecoration: "unset",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  rounded: {
    borderRadius: "15px",
    "@media (max-width: 599px)": {
      borderRadius: "0px",
    },
  },
  shadow: {
    boxShadow: "0px 0px 32px rgb(0 0 0 / 30%)",
  },
  fheight: {
    "@media (max-width: 599px)": {
      minHeight: "100vh",
    },
  },
}));

const defaultValues = { email: "" };

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Некорректный электронный адрес").required("Укажите электронный адрес"),
});

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { forgotPassword, logout } = useAuth();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  useDocTitle("Сброс пароля");

  useEffect(() => {
    let token = localStorage.getItem("accessToken");
    if (token) logout();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await forgotPassword(data.email);
      setLoading(false);
      dispatch(
        notify({
          title: "Выполнено",
          message: "Пароль успешно сброшен",
          status: "success",
          image: "/public/assets/images/illustrations/check.svg",
        })
      );
    } catch (e) {
      setLoading(false);
      dispatch(
        notify({
          title: "Ошибка",
          message: e.message,
          status: "error",
          image: "/public/assets/images/illustrations/close.svg",
        })
      );
    }
  };

  return (
    <div className={clsx("flex justify-center items-center min-h-full-screen", classes.cardHolder)}>
      <Card className={clsx(classes.rounded, classes.shadow, classes.fheight)} style={{ maxWidth: "750px" }}>
        <Grid container>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <div className="p-8 flex-column justify-center items-center h-full">
              <img className="w-200" src="/public/assets/images/Garveks.svg" alt="Логотип Гарвекс" height="100px" />
              <Typography component="h1" variant="h4" color="primary" className={classes.header}>
                Восстановить пароль
              </Typography>
            </div>
          </Grid>
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <div className="p-8 h-full relative">
              <MyForm onSubmit={onSubmit} defaultValues={defaultValues} validationSchema={validationSchema}>
                <MyInput name="email" label="Логин" type="email" required={true} margin="normal" disabled={loading} />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.submit}
                  disabled={loading}
                  startIcon={loading && <CircularProgress size={20} />}
                >
                  {!loading ? "Сбросить пароль" : "Выполняется сброс..."}
                </Button>
              </MyForm>
              <Grid container>
                <Grid item xs={12} className="text-center">
                  <Link to="/signin" className={classes.link}>
                    Вход
                  </Link>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default ForgotPassword;
